import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'

import usePageLoaded from '../../hooks/usePageLoaded'
import { useShowBackButton } from '../../hooks/useBackButton'

import Title from '../../components/ui/title/title'
import VirtualGift from '../../components/profile/virtualGifts/VirtualGift'
import PaginationWrapper from '../../components/pagination/paginationWrapper'
import WalletPoints from '../../components/profile/wallet/WalletPoints'

import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'
import { getLangFromPath, getPrefixFromPath } from '../../i18next'
import { MyGift, UnionGift } from '../../store/member/memberTypings'
import { fetchMemberGifts } from '../../store/member/memberSlice'
import { checkAuth, loadMemberGifts } from '../../utils/auth'
import { fetchProfile, fetchProfileGifts } from '../../store/profile/profileSlice'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import './virtualGifts.sass'
import paths from '../../paths'
import PageHeader from '../../components/profile/pageHeader'
import s from '../../components/profile/materials/materialPreview.module.sass'

const VirtualGifts = () => {
    usePageLoaded()
    useShowBackButton()

    const [t] = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()

    const self = location.pathname.includes('/membre')

    const { user, virtualGifts, virtualGiftsTotal } = useSelector((state: RootState) => state.member)
    const { user: profileUser, userGifts, userGiftsTotal } = useSelector((state: RootState) => state.profile)

    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        if (self) {
            dispatch(fetchMemberGifts({ p: currentPage }))
        } else if (!self) {
            dispatch(fetchProfileGifts({ user_id: profileUser.id, p: currentPage }))
        }
    }, [currentPage])

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>
                    {self
                        ? META.myVirtualGifts[getLangFromPath(location.pathname)].title
                        : META.userVirtualGifts[getLangFromPath(location.pathname)].title + profileUser.nick}
                </title>
                <meta
                    name="description"
                    content={
                        self
                            ? META.notifications[getLangFromPath(location.pathname)].description
                            : META.userVirtualGifts[getLangFromPath(location.pathname)].description
                    }
                />
            </Helmet>

            <div className="pageRow" style={{ marginBottom: '20px' }}>
                <PageHeader user={self ? user : profileUser} self={self} text={t('My virtual gifts')} />
            </div>

            {/*{!self && (*/}
            {/*    <div className={'giftLinkToProfile'}>*/}
            {/*        <Link to={{ pathname: createLocalizedPath(`/profil/${profileUser.nick}`) }} className={'nickLink'}>*/}
            {/*            {t('Back to profile of') + profileUser.nick}*/}
            {/*        </Link>*/}
            {/*        /!*<WalletPoints />*!/*/}
            {/*    </div>*/}
            {/*)}*/}
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__row']}>
                    <div className={s['materialsPreview__title']}>{t('Virtual gifts')}</div>
                    <div className={s['materialsPreview__counter']}>{self ? virtualGiftsTotal : userGiftsTotal}</div>
                </div>
            </div>
            <div className={'giftsWrapper'}>
                {self ? (
                    virtualGifts.length ? (
                        virtualGifts.map((item: MyGift, index: number) => (
                            <VirtualGift virtualGift={item} key={index} />
                        ))
                    ) : (
                        <p>{t('You dont have any gifts')}</p>
                    )
                ) : userGifts.length ? (
                    userGifts.map((item: UnionGift, index: React.Key) => (
                        <VirtualGift virtualGift={item} short userAlbum={!self} key={index} isOutgoing={false} />
                    ))
                ) : (
                    <p>{profileUser.nick + t('doesnt have any gifts')}</p>
                )}
            </div>
            {(self ? virtualGiftsTotal : userGiftsTotal) > 20 && (
                <PaginationWrapper
                    limit={20}
                    limitOptions={20}
                    maxButtons={5}
                    activePage={currentPage}
                    onchange={(page: number) => {
                        setCurrentPage(page)
                    }}
                    total={self ? Number(virtualGiftsTotal) : Number(userGiftsTotal)}
                />
            )}
            {self && (
                <div className={'virtualGiftsInfo'}>
                    <img src={require('./../../assets/ic-eye-cross.svg')} />
                    <p>{t('You can hide your virtual gifts')}</p>
                </div>
            )}
        </div>
    )
}

// @ts-ignore
VirtualGifts.getInitialProps = async ({ req, store, match }) => {
    const self = match.path.includes('/membre')
    await checkAuth(store)

    const {
        member: { loggedIn }
    } = store.getState()

    if (loggedIn && self) {
        await loadMemberGifts(store)
    } else {
        if (!loggedIn && self)
            return {
                redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${paths.myVirtualGifts.path}`
            }
    }

    const {
        params: { nick }
    } = match

    await store.dispatch(fetchProfile({ nick }))
    const {
        profile: { user }
    } = store.getState()

    if (loggedIn && self) {
        await store.dispatch(fetchMemberGifts({ p: 1 }))
    } else if (!self) {
        if (!user) return { statusCode: 404 }
        await store.dispatch(fetchProfileGifts({ user_id: user.id }))
    }
}

export default VirtualGifts
